/**
 * State used in rendering DialogBody
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
